// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OXIO","left":"styles_left__1Eeqc"};